import * as api from '@gitbook/api-client';
import { Button, useDialogAction } from '@gitbook/spine-react';
import type { MandateProps } from '@gitbook/util-ts';

import { useNavigation } from '../../../navigation';

export function ChangeSitePlanBillingInterval({
    organization,
}: {
    organization: MandateProps<api.Organization, 'billing'>;
}) {
    const isYearly = organization.billing.interval === api.BillingInterval.Yearly;
    const [, startDialogAction] = useDialogAction();
    const { navigate } = useNavigation();

    const navigateToBillingPage = () => {
        startDialogAction(async ({ close }) => {
            navigate({
                screen: {
                    type: 'org_settings',
                    organization: organization.id,
                    tab: {
                        type: 'plans',
                        interval: isYearly ? 'monthly' : 'yearly',
                    },
                },
            });
            await close();
        });
    };

    return (
        <span className="text-muted text-ui-small">
            {isYearly ? (
                <>
                    Billed annually.{' '}
                    <Button
                        size="small"
                        kind="link"
                        label="Switch to monthly"
                        onPress={navigateToBillingPage}
                        className="text-primary no-underline hover:underline"
                    />
                    .
                </>
            ) : (
                <>
                    Billed monthly.{' '}
                    <Button
                        size="small"
                        kind="link"
                        label="Switch to annual"
                        onPress={navigateToBillingPage}
                        className="text-upgrade no-underline hover:underline"
                    />{' '}
                    and get 2 months for free!
                </>
            )}
        </span>
    );
}
